export default __webpack_public_path__ + "static/media/WNo.7-8.b8887542.jpg";